import { ReactComponent as IconStepper } from '@/assets/svgs/stepper.svg'
import classname from 'classnames'
import { uniqueId } from 'lodash'
import MultiClamp from 'react-multi-clamp'

const StepList = ({ steps, step, selected = [] }) => {

	const Step = steps.map((item, index) => {
		const id = uniqueId()

		const stepClass = classname({
			'steps-2__item': true,
			'steps-2__item--active': index === step - 1,
			'steps-2__item--completed': index < step - 1,
		})

		const stepperClass = classname({
			'steps-2__item__stepper': true,
			'steps-2__item__stepper--active': index <= step - 1
		})

		return (
			<div className="steps-2__col" key={id}>
				<div className={stepClass}>
					{index !== 0 && (<div className={stepperClass}><IconStepper /></div>)}
					<div className="steps-2__item__left">
						<div className="steps-2__circle">{index + 1}</div>
					</div>
					<div className="steps-2__item__right">
						<div className="steps-2__item__value">
							{item}
						</div>
						{(index < step - 1) && (selected[index]) ? (
							<div className="steps-2__data-item-name"><MultiClamp clamp={1}>{selected[index]}</MultiClamp></div>
						) : (
							<div className="steps-2__item__stroke"></div>
						)}
					</div>
				</div>
			</div>
		)
	})

	return (
		<div className="steps-2">
			<div className="steps-2__cols">
				{Step}
			</div>
		</div>
	)

}

export default StepList
